export default __webpack_public_path__ + "static/media/whyBlog.e4476061.jpg";